<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="BMH"><span class="ePub-BI-2">CONTENTS</span></p>
<p class="toc"><span href="#/xhtml/frontispiece#fro" title="Link target outside of Sample">Frontispiece</span></p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><span href="#/xhtml/dedication#ded" title="Link target outside of Sample">Dedication</span></p>
<p class="toc"><a href="#/xhtml/sail#sai">The Sail</a></p>
<p class="toc-bot"><a href="#/xhtml/map#map">Map</a></p>
<p class="toc"><a href="#/xhtml/prologue#pro">Prologue</a></p>
<p class="toc"><a href="#/xhtml/chapter1#ch1">Chapter 1</a></p>
<p class="toc"><span href="#/xhtml/chapter2#ch2" title="Link target outside of Sample">Chapter 2</span></p>
<p class="toc"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">Chapter 3</span></p>
<p class="toc"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">Chapter 4</span></p>
<p class="toc-bot"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toc"><span href="#/xhtml/acknowledgments#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span href="#/xhtml/adcard#adc" title="Link target outside of Sample">Also by Christian Brechneff</span></p>
<p class="toc"><span href="#/xhtml/noteaboutauthor#ata" title="Link target outside of Sample">A Note About the Author</span></p>
<p class="toc"><span href="#/xhtml/copyright#crt" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?ce45c97c